/**
 * A small labelled figure.
 *
 * Used by the puzzle cards and the profile; kept in one place so the label size,
 * opacity and mono numerals stay identical wherever a statistic appears.
 */
export function Stat({
  label,
  value,
  note,
  size = "compact",
}: {
  readonly label: string;
  readonly value: string;
  /** Sits beside the value, for context like "from 12". */
  readonly note?: string;
  /** `panel` boxes the figure, for a standalone summary tile. */
  readonly size?: "compact" | "panel";
}) {
  const body = (
    <>
      <span className="meta block text-[0.625rem] opacity-60">{label}</span>
      <span className={size === "panel" ? "font-mono text-3xl leading-none" : "font-mono text-lg leading-none"}>
        {value}
      </span>
      {note ? <span className="meta ml-1.5 text-[0.625rem] opacity-50">{note}</span> : null}
    </>
  );

  return size === "panel" ? <div className="panel px-5 py-4">{body}</div> : <div>{body}</div>;
}
